module.exports = __webpack_public_path__ + "static/img/hjq.7cf5e2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/hjq.jpg
// module id = rTPW
// module chunks = 21